// constants
import { DWEB_HEADER_HEIGHT } from 'shared/styles/base';
import { SLIDE_MARGIN, IMAGE_HEIGHT, CAROUSEL_TOP_MARGIN } from './constants';

/**
 * This function return carousel height and number of carousel item
 * we can support
 * NOTE - this function should be executed in browser only
 */
export const getCarouselDimension = () => {
  const availableHeight =
    window.innerHeight - DWEB_HEADER_HEIGHT - CAROUSEL_TOP_MARGIN + SLIDE_MARGIN;

  let visibleItems = Math.floor(availableHeight / (IMAGE_HEIGHT + SLIDE_MARGIN)) - 1;

  if (visibleItems < 1) {
    visibleItems = 1;
  }

  if (visibleItems > 5) {
    visibleItems = 5;
  }

  const carouselHeight =
    visibleItems * IMAGE_HEIGHT + visibleItems * SLIDE_MARGIN + IMAGE_HEIGHT / 2;
  return { carouselHeight, visibleItems };
};
